import { QRFC } from "./QRFC";

export class QQueryUniqueValues extends QRFC {
  constructor() {
    super();
    this.fFieldName = null;
    this.fValueIdx = null;
  }

  InitQueryUniques(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qqueryuniques";
  }

  SetParams(
    orgName,
    user,
    fieldName,
    chartID,
    srcElement,
    baseCode,
    isArchive = false,
    onlyFromType = null
  ) {
    this.fFieldName = fieldName;
    if (srcElement) this.fSrcElement = srcElement;
    if (baseCode) this.fNextCmd = baseCode;

    this.AddEncodedParameter("org", orgName);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("field", fieldName);
    this.AddEncodedParameter("chartID", chartID);
    this.AddEncodedParameter("isArchive", isArchive);
    if (onlyFromType) this.AddEncodedParameter("onlyFromType", onlyFromType);

    if (this.fIncludeRawVals) this.AddEncodedParameter("includeRawVals", true);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var success = r["success"];
    callBackObj.fBusy = false;
    if (this.isImportFilter)
      callBackObj.QueryUniqueValuesFilter(
        success,
        this.fFieldName,
        null,
        r["data"],
        this.fSrcElement,
        this.fValueIdx
      );
    else
      callBackObj.QueryUniqueValuesResponse(
        success,
        this.fFieldName,
        this.fIndex,
        r["data"],
        this.fValueIdx,
        this.fSrcElement,
        this.fNextCmd,
        this.fSrcCmd
      );
  }

  DoTransactionFailed(response, callBackObj) {
    if (callBackObj?.DoTransactionFailed) {
      return callBackObj.DoTransactionFailed(response, callBackObj);
    }

    return super.DoTransactionFailed(response, callBackObj);
  }
}
